import {
  Box,
  Card,
  CircularProgress,
  Dialog,
  DialogContent,
  Grid2,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import TableContainerComp from "../../Component/TableContainer";
import { Link } from "react-router-dom";
import { saveAs } from "file-saver";
import {
  Beenhere,
  BookmarkAdded,
  Check,
  Clear,
  NotInterestedOutlined,
  Print,
  RateReview,
} from "@mui/icons-material";
import { commonCss } from "../../StyleConfig/CommonCss";
import CircleIcon from "@mui/icons-material/Circle";
import {
  api,
  companyInfo,
  riskLevelInfo,
  roleInfo,
  roleNameString,
} from "../API/config";
import { axiosPrivate } from "../../axios/axios";
import moment from "moment";
import NewForm from "./NewForm";
import { useDispatch, useSelector } from "react-redux";
import { permitStatus } from "../../Redux/data";
import { toast } from "react-toastify";
import Loading from "../../Component/Loading";

const FormsList = () => {
  const login = useSelector((state) => state.auth.loginInfo);
  const loginRoleId = String(login.roleIds).split(",");
  const [roleName, setRoleName] = useState("");

  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [newForm, setNewForm] = useState(false);
  const [pendingValue, setPendingValue] = useState(true);
  const [count, setCount] = useState({
    new: [],
    pending: [],
    approved: [],
    reject: [],
    cancel: [],
    close: [],
  });

  const [print, setPrint] = useState(false);
  const [terminal, setTerminal] = useState([]);

  const [backUp, setBackUp] = useState([]);
  const [roleAccess, setRoleAccess] = useState({
    // admin: loginRoleId.includes(roleInfo.admin)&&login.companyId===companyInfo.ps,
    admin: false,
    // externalAdmin:loginRoleId.includes(roleInfo.admin)&&!(login.companyId===companyInfo.ps),
    externalAdmin: false,
    // adminContractTech:
    //   loginRoleId.includes(roleInfo.admin) ||
    //   loginRoleId.includes(roleInfo.contractStaff) ||
    //   loginRoleId.includes(roleInfo.technican),
    adminContractTech: false,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getData(pendingValue);
    getTerminal();
  }, [window.location.pathname]);

  const getTerminal = () => {
    const getTerminalLink = api.terminal.getAll;
    axiosPrivate
      .get(`${getTerminalLink}`)
      .then((res) => {
        setTerminal(res.data.data);
      })
      .catch((e) => {
        setTerminal([]);
        console.log(e);
      });
  };

  const getData = (valuePending) => {
    setLoading(true);
    const roleNameGet = atob(window.location.pathname.split("/")[2]);
    console.log("roleNameGet", roleNameGet);
    setRoleName(roleNameGet);

    const roleAccessAdmin =
      roleNameGet.toLowerCase() === roleNameString.admin &&
      login.companyId === companyInfo.ps;
    const roleAccessExternalAdmin =
      roleNameGet.toLowerCase() === roleNameString.admin &&
      !(login.companyId === companyInfo.ps);
    const roleAccessAdminContractTech =
      roleNameGet.toLowerCase() === roleNameString.admin ||
      roleNameGet.toLowerCase() === roleNameString.contractStaff ||
      roleNameGet.toLowerCase() === roleNameString.technican;
    setRoleAccess({
      admin: roleAccessAdmin,
      externalAdmin: roleAccessExternalAdmin,
      adminContractTech: roleAccessAdminContractTech,
    });
    const getForm = api.PTWForm.getAllByRole;
    const getAllForm = api.PTWForm.getAllForm;
    const getByCompanyId = api.PTWForm.getByCompanyId;

    axiosPrivate
      .get(
        roleAccessAdmin
          ? `${getAllForm}`
          : roleAccessExternalAdmin
            ? `${getByCompanyId}?companyId=${login.companyId}`
            : `${getForm}?isPendingOnly=${valuePending}&RoleName=${roleNameGet}`,
      )
      .then((res) => {
        console.log(res);
        const resData = res.data.data;
        const newFilter = resData.filter((fil) => fil.formStatus === 1);
        const pendingFilter = resData.filter((fil) => fil.formStatus === 2);
        const rejectFilter = resData.filter((fil) => fil.formStatus === 4);
        const approveFilter = resData.filter(
          (fil) => fil.formStatus === 3 || fil.formStatus === 6,
        );
        const cancelFilter = resData.filter((fil) => fil.formStatus === 9);
        const closeFilter = resData.filter(
          (fil) =>
            fil.formStatus === 5 ||
            fil.formStatus === 7 ||
            fil.formStatus === 8,
        );
        setCount({
          new: newFilter,
          pending: pendingFilter,
          reject: rejectFilter,
          approved: approveFilter,
          cancel: cancelFilter,
          close: closeFilter,
        });
        setData(res.data.data);
        setBackUp(res.data.data);
        setLoading(false);
      })
      .catch((e) => {
        setData([]);
        setBackUp([]);
        console.log(e);
      });
  };

  const handlePrint = (id, formNo) => {
    setPrint(true);
    const printlink = api.PTWForm.print;
    axiosPrivate
      .get(
        `${printlink}?id=${id}&&pageSize=a4&&printBackground=false&&margin=0`,
        {
          responseType: "blob",
        },
      )
      .then((res) => {
        console.log(res);
        const blob = res.data;
        saveAs(blob, `Form-${formNo}.pdf`);
        setPrint(false);
      })
      .catch((e) => {
        console.log(e);
        setPrint(false);
        toast.error(e.response.data.message);
      });
  };

  const getCertificates = (row) => {
    const certificates = [];
    const colorMap = {
      HW: { bg: "#FFE8CC", text: "#D97706" }, // Hot Work - Light Orange
      CS: { bg: "#FEE2E2", text: "#DC2626" }, // Confined Space - Light Red
      ISO: { bg: "#E9D5FF", text: "#7C3AED" }, // Isolation - Light Purple
      RAD: { bg: "#DBEAFE", text: "#2563EB" }, // Radiation - Light Blue
      EXC: { bg: "#CCFBF1", text: "#0D9488" }, // Excavation - Light Teal
      OVR: { bg: "#FED7AA", text: "#B45309" }, // Safe Override - Light Brown
      HL: { bg: "#DCFCE7", text: "#16A34A" }, // Lifting & Hoisting - Light Green
    };

    if (row.certificateNames) {
      const certNames = row.certificateNames
        .split(" ")
        .map((name) => name.trim());
      certNames.forEach((name) => {
        if (colorMap[name]) {
          certificates.push({ label: name, ...colorMap[name] });
        }
      });
    }
    return certificates;
  };

  const columns = [
    {
      Header: "Form No",
      accessor: "seqNo",
      Cell: ({ cell }) => {
        return (
          <Link
            to={`/ptwform?id=${btoa(cell.row.original.id)}&no=${cell.value}&requestor=${btoa(roleName)}`}
            style={{
              color: commonCss.blue,
              textDecorationLine: "underline",
              textDecorationColor: commonCss.blue,
              textDecorationThickness: "1.5px",
              fontWeight: 900,
              fontSize: "inherit",
            }}
            onClick={() => {
              dispatch(
                permitStatus({
                  permitStatus: cell.row.original.permitStatus,
                  isPermitShift: cell.row.original.isPermitShift,
                }),
              );
            }}
          >
            {cell.value}
          </Link>
        );
      },
    },
    {
      Header: "Contractor",
      accessor: "contractor",
    },
    {
      Header: "Terminal",
      accessor: "terminalId",
      Cell: ({ cell }) => {
        const terminalName = terminal.find(
          (term) => term.id === cell.value,
        )?.name;
        return (
          <Typography
            sx={{
              fontSize: "inherit",
              fontWeight: "inherit",
              color: "inherit",
            }}
          >
            {terminalName}
          </Typography>
        );
      },
    },
    {
      Header: "Certificates",
      accessor: "certificateNames",
      // disableFilters: true,
      Cell: ({ cell }) => {
        const certificates = getCertificates(cell.row.original);
        return (
          <Box sx={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
            {certificates.map((cert, index) => (
              <Box
                key={index}
                sx={{
                  backgroundColor: cert.bg,
                  color: cert.text,
                  padding: "0.2rem 0.5rem",
                  borderRadius: "4px",
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  whiteSpace: "nowrap",
                }}
              >
                {cert.label}
              </Box>
            ))}
          </Box>
        );
      },
    },
    {
      Header: "Date",
      accessor: "issueDate",
      Cell: ({ cell }) => {
        return (
          <Typography
            sx={{
              fontSize: "inherit",
              fontWeight: "inherit",
              color: "inherit",
            }}
          >
            {cell.value !== null
              ? moment(cell.value).format("DD/MM/YYYY")
              : null}
          </Typography>
        );
      },
    },
    {
      Header: "Location",
      accessor: "locationText",
    },
    
    {
      Header: "Status",
      accessor: "formStatusText",
      Cell: ({ cell }) => {
        return (
          <Typography
            sx={{
              fontSize: "inherit",
              fontWeight: "inherit",
              color: "inherit",
            }}
          >
            {/* {cell.row.original.deIsolationStatus&&cell.value.toUpperCase()==="CLOSED"?"Deisolation":cell.value} */}
            {cell.value?.toLowerCase() === "close/adopted"
              ? "Closed"
              : cell.value}
            <IconButton
              sx={{
                display:
                  (((!cell.row.original.isIsolationOwnerApproved ||
                    !cell.row.original.isIsolationVerifierApproved) &&
                    (!cell.row.original.enableConfinedSpaceCertificate &&
                    !cell.row.original.enableLiftingAndHoistingCertificate &&
                    !cell.row.original.enableHotWorkCertificate &&
                    !cell.row.original.enableExcavationCertificate &&
                    !cell.row.original.enableIsolationCertificate &&
                    !cell.row.original.enableRadiationCertificate &&
                    !cell.row.original.enableSystemOverridingCertificate
                      ? cell.row.original.isPermitIssuerApproved
                      : cell.row.original.isLeadPermitIssuerApproved)) ||
                    ((!cell.row.original.isdeIsolationOwnerClosed ||
                      !cell.row.original.isdeIsolationVerifierClosed) &&
                      cell.row.original.isPHPermitClosed === true)) &&
                  cell.row.original.enableIsolationCertificate &&
                  !cell.row.original.isPermitClosed
                    ? "default"
                    : "none",
              }}
            >
              <CircleIcon
                sx={{
                  color: commonCss.yellow,
                  fontSize: "0.6rem",
                }}
              />
            </IconButton>
          </Typography>
        );
      },
    },
    {
      accessor: "isPermitShift",
      disableFilters: true,
      Cell: ({ cell }) => {
        return (
          <>
            {cell.row.original.formStatusText.toLowerCase() === "rejected" ||
            cell.row.original.formStatusText.toLowerCase() ===
              "amended" ? null : !cell.row.original.isPermitClosed &&
              !cell.row.original.isCancel ? (
              (cell.row.original.riskLevelId === riskLevelInfo.low
                ? cell.row.original.isPermitIssuerApproved
                : cell.row.original.isLeadPermitIssuerApproved) &&
              moment().isAfter(
                moment(cell.row.original.piPermitValidUpTo).format(
                  "YYYY-MM-DD",
                ),
                "day",
              ) ? (
                // cell.row.original.isFormExpired ?
                <Typography
                  sx={{
                    fontSize: "inherit",
                    fontWeight: "inherit",
                    color: commonCss.red,
                  }}
                >
                  Expired
                </Typography>
              ) : (cell.row.original.riskLevelId === riskLevelInfo.low
                  ? cell.row.original.isPermitIssuerApproved
                  : cell.row.original.isLeadPermitIssuerApproved) &&
                !cell.row.original.isPHPermitClosed ? (
                cell.value ? (
                  <Typography
                    sx={{
                      fontSize: "inherit",
                      fontWeight: "inherit",
                      color: "rgb(0, 86, 151)",
                    }}
                  >
                    Active
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      fontSize: "inherit",
                      fontWeight: "inherit",
                      color: commonCss.red,
                    }}
                  >
                    Suspend
                  </Typography>
                )
              ) : null
            ) : null}
          </>
        );
      },
    },
    {
      accessor: "action",
      disableFilters: true,
      Cell: ({ cell }) => {
        return (
          <IconButton
            disabled={cell.row.original.formStatusText === "New"}
            onClick={() => {
              handlePrint(cell.row.original.id, cell.row.original.seqNo);
            }}
          >
            <Print />
          </IconButton>
        );
      },
    },
  ];

  const newButton = () => {
    setNewForm(true);
  };

  const pendingChange = (e) => {
    setPendingValue(e);
    getData(e);
  };

  const handleCard = (value) => {
    setData(count[value]);
  };
  const handleShowAll = () => {
    setData(backUp);
  };

  return (
    <>
      {loading ? (
        <Loading color={commonCss.blue} />
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Grid2 container size={12} mb={"1rem"} spacing={"1rem"}>
            <Grid2
              size={{
                xs: 12,
                md: 4,
                xl: roleAccess.adminContractTech ? 2 : 2.4,
              }}
            >
              <Card
                sx={{
                  wordWrap: "break-word",
                  backgroundColor: commonCss.cardNewColor,
                  padding: "0.8rem 1rem",
                  cursor: "pointer",
                  // height:"12vh"
                }}
                onClick={() => {
                  handleCard("new");
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        wordWrap: "break-word",
                        fontSize: "0.9rem",
                        fontWeight: 800,
                        color: "white",
                        textTransform: "uppercase",
                        letterSpacing: "0.3px",
                      }}
                    >
                      New
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        color: "white",
                        fontSize: "1.7rem",
                        mt: "0.5rem",
                      }}
                    >
                      {count.new.length}
                    </Typography>
                  </Box>
                  <Box>
                    <RateReview sx={{ fontSize: "4rem", color: "white" }} />
                  </Box>
                </Box>
              </Card>
            </Grid2>
            <Grid2
              size={{
                xs: 12,
                md: 4,
                xl: roleAccess.adminContractTech ? 2 : 2.4,
              }}
            >
              <Card
                sx={{
                  wordWrap: "break-word",
                  backgroundColor: commonCss.cardProgressColor,
                  padding: "0.8rem 1rem",
                  cursor: "pointer",
                  // height:"12vh"
                }}
                onClick={() => {
                  handleCard("pending");
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Box>
                    <Typography
                      sx={{
                        wordWrap: "break-word",
                        fontSize: "0.9rem",
                        fontWeight: 800,
                        color: "white",
                        textTransform: "uppercase",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Progress
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        color: "white",
                        fontSize: "1.7rem",
                        mt: "0.5rem",
                      }}
                    >
                      {count.pending.length}
                    </Typography>
                  </Box>
                  <Box>
                    <Check sx={{ fontSize: "4rem", color: "white" }} />
                  </Box>
                </Box>
              </Card>
            </Grid2>
            <Grid2
              size={{
                xs: 12,
                md: 4,
                xl: roleAccess.adminContractTech ? 2 : 2.4,
              }}
            >
              <Card
                sx={{
                  wordWrap: "break-word",
                  backgroundColor: commonCss.cardRejectedColor,
                  padding: "0.8rem 1rem",
                  cursor: "pointer",
                  // height:"12vh"
                }}
                onClick={() => {
                  handleCard("reject");
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Box>
                    <Typography
                      sx={{
                        wordWrap: "break-word",
                        fontSize: "0.9rem",
                        fontWeight: 800,
                        color: "white",
                        textTransform: "uppercase",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Rejected
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        color: "white",
                        fontSize: "1.7rem",
                        mt: "0.5rem",
                      }}
                    >
                      {count.reject.length}
                    </Typography>
                  </Box>
                  <Box>
                    <NotInterestedOutlined
                      sx={{ fontSize: "4rem", color: "white" }}
                    />
                  </Box>
                </Box>
              </Card>
            </Grid2>
            <Grid2
              size={{
                xs: 12,
                md: 4,
                xl: roleAccess.adminContractTech ? 2 : 2.4,
              }}
            >
              <Card
                sx={{
                  wordWrap: "break-word",
                  backgroundColor: commonCss.cardApprovedColor,
                  padding: "0.8rem 1rem",
                  cursor: "pointer",
                  // height:"12vh"
                }}
                onClick={() => {
                  handleCard("approved");
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Box>
                    <Typography
                      sx={{
                        wordWrap: "break-word",
                        fontSize: "0.9rem",
                        fontWeight: 800,
                        color: "white",
                        textTransform: "uppercase",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Approved
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        color: "white",
                        fontSize: "1.7rem",
                        mt: "0.5rem",
                      }}
                    >
                      {count.approved.length}
                    </Typography>
                  </Box>
                  <Box>
                    <Beenhere sx={{ fontSize: "4rem", color: "white" }} />
                  </Box>
                </Box>
              </Card>
            </Grid2>
            <Grid2
              size={{
                xs: 12,
                md: 4,
                xl: roleAccess.adminContractTech ? 2 : 2.4,
              }}
              sx={{
                display: roleAccess.adminContractTech ? "default" : "none",
              }}
            >
              <Card
                sx={{
                  wordWrap: "break-word",
                  backgroundColor: commonCss.cardCancelColor,
                  padding: "0.8rem 1rem",
                  cursor: "pointer",
                  // height:"12vh"
                }}
                onClick={() => {
                  handleCard("cancel");
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Box>
                    <Typography
                      sx={{
                        wordWrap: "break-word",
                        fontSize: "0.9rem",
                        fontWeight: 800,
                        color: "white",
                        textTransform: "uppercase",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Cancel
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        color: "white",
                        fontSize: "1.7rem",
                        mt: "0.5rem",
                      }}
                    >
                      {count.cancel.length}
                    </Typography>
                  </Box>
                  <Box>
                    <Clear sx={{ fontSize: "4rem", color: "white" }} />
                  </Box>
                </Box>
              </Card>
            </Grid2>
            <Grid2
              size={{
                xs: 12,
                md: 4,
                xl: roleAccess.adminContractTech ? 2 : 2.4,
              }}
            >
              <Card
                sx={{
                  wordWrap: "break-word",
                  backgroundColor: commonCss.cardCloseColor,
                  padding: "0.8rem 1rem",
                  cursor: "pointer",
                  // height:"12vh"
                }}
                onClick={() => {
                  handleCard("close");
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Box>
                    <Typography
                      sx={{
                        wordWrap: "break-word",
                        fontSize: "0.9rem",
                        fontWeight: 800,
                        color: "white",
                        textTransform: "uppercase",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Close
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        color: "white",
                        fontSize: "1.7rem",
                        mt: "0.5rem",
                      }}
                    >
                      {count.close.length}
                    </Typography>
                  </Box>
                  <Box>
                    <BookmarkAdded sx={{ fontSize: "4rem", color: "white" }} />
                  </Box>
                </Box>
              </Card>
            </Grid2>
          </Grid2>
          {/* <Typography
        sx={{
          color: "white",
          fontSize: "1.5rem",
          fontWeight: 600,
          mb: "1rem",
        }}
      >
        PTW Forms
      </Typography> */}

          <TableContainerComp
            columns={columns}
            data={data}
            formListMain={true}
            buttonNew={newButton}
            buttonDisable={!(login.companyId === companyInfo.ps)}
            filterShow={true}
            pendingShow={roleAccess.admin ? false : true}
            pendingValue={pendingValue}
            handleChangePending={pendingChange}
            showAll={roleAccess.admin}
            handleShowAll={handleShowAll}
          />

          <Dialog
            // maxWidth={"lg"}
            open={newForm}
            onClose={() => {
              setNewForm(false);
              getData();
            }}
            PaperProps={{
              sx: {
                maxWidth: { xs: "100vw", md: "80vw", lg: "70vw" },
                width: { xs: "100vw", md: "80vw", lg: "70vw" },
                background: "rgb(0, 86, 151)",
                borderRadius: "10px",
              },
            }}
          >
            <DialogContent>
              <NewForm
                handleCloseClick={() => {
                  setNewForm(false);
                  getData(true);
                }}
              />
            </DialogContent>
          </Dialog>
          <Dialog
            maxWidth={"sm"}
            open={print}
            onClose={() => {
              setPrint(true);
            }}
            PaperProps={{
              sx: {
                background: "white",
                borderRadius: "10px",
              },
            }}
          >
            <DialogContent>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ color: "rgb(0, 86, 151)", fontWeight: 450 }}>
                  Printing
                </Typography>
                <CircularProgress
                  disableShrink
                  sx={{ color: "rgb(0, 86, 151)" }}
                />
              </Box>
            </DialogContent>
          </Dialog>
        </Box>
      )}
    </>
  );
};

export default FormsList;
